import { InjectionToken } from '@angular/core';

// {APP_REVISION} will be replaced during build step,
// it is used by sentry to match sourcemaps

export const AppRevisionToken = new InjectionToken('APP_REVISION');
export const AppRevisionProvider = {
  provide: AppRevisionToken,
  useValue: `{APP_REVISION}`,
};
